import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axiosInstance from '../../axiosConfig';
import {
    IFacilityShareContentType,
    IFacilityShareResponse,
} from '../../dto/FacilitySharing.dto';
import { AxiosErrorToast } from '../general/ReusableFunctions';
import { getFacilityShareApiPath, getFacilityShareQueryKey } from './useRqFacilityShare';

const getFacilityShareDetail = async (
  companyId: number,
  contentType: IFacilityShareContentType,
  contentId: number,
): Promise<IFacilityShareResponse | null> => {
  try {
    const response: AxiosResponse<IFacilityShareResponse> = await axiosInstance.get(
      getFacilityShareApiPath(companyId, contentType, contentId),
    );

    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;

    if (axiosError.response?.status === 404) {
      return null;
    }

    AxiosErrorToast(axiosError, 'Error loading facility share');
    throw axiosError;
  }
};

export const useRqFacilityShareDetail = (
  companyId: number,
  contentType: IFacilityShareContentType,
  contentId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: getFacilityShareQueryKey(companyId, contentType, contentId),
    queryFn: () => getFacilityShareDetail(companyId, contentType, contentId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled && Boolean(companyId && contentId),
  });
};